import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import axios from 'axios';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const searchOrders = async (
  {
    companyName,
    ShipCity,
    supplyTypes,
    templateNo,
    dueDateFrom,
    dueDateTo,
    orderNumber,
    clientIDs,
    rushOrder,
    reportAddressIDs,
    invoiceAddressIDs,
    shipToFacility,
    shipToCompany,
    statusIDs,
    requestor,
    page,
    pageSize,
    sortBy,
  }
) => {
  const queryParams = [];
  if (companyName) {
    queryParams.push(`companyName=${encodeURIComponent(companyName)}`);
    queryParams.push('companyName=Contains');
  }

  if (orderNumber) {
    queryParams.push(`orderNumber=${encodeURIComponent(orderNumber)}`);
  }
  if (ShipCity) {
    queryParams.push(`shipToCity=${encodeURIComponent(ShipCity)}`);
  }
  if (requestor) {
    queryParams.push(`requestor=${requestor?.id}`);
  }

  if (dueDateFrom) {
    queryParams.push(`dueDateFrom=${dueDateFrom}`);
  }

  if (dueDateTo) {
    queryParams.push(`dueDateTo=${dueDateTo}`);
  }
  if (templateNo) {
    queryParams.push(`templateNo=${encodeURIComponent(templateNo?.id)}`);
  }
  if (clientIDs?.length) {
    queryParams.push(`clientIDs=${clientIDs.map((client) => client?.id || client).join(',')}`);
  }
  if (supplyTypes?.length) {
    queryParams.push(`supplyTypes=${supplyTypes.map((supply) => supply.id).join(',')}`);
  }
  if (reportAddressIDs?.length) {
    queryParams.push(`reportAddressIDs=${reportAddressIDs.map((report) => report.id).join(',')}`);
  }
  if (invoiceAddressIDs?.length) {
    queryParams.push(`invoiceAddressIDs=${invoiceAddressIDs.map((invoice) => invoice.id).join(',')}`);
  }
  if (statusIDs?.length) {
    queryParams.push(`statusIDs=${statusIDs.map((st) => st.id).join(',')}`);
  }
  if (rushOrder) {
    queryParams.push(`rushOrder=${encodeURIComponent(rushOrder)}`);
  }
  if (shipToFacility) {
    queryParams.push(`shipToFacility=${encodeURIComponent(shipToFacility?.id)}`);
  }
  if (shipToCompany?.length) {
    queryParams.push(`shipToCompany=${shipToCompany?.map((company) => company.id).join(',')}`);
  }
  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(
      `/Orders/Search/By?${queryParams.join('&')}`
    );

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const OrderCreate = async (requestPayload) => {
  try {
    const response = await axiosInstance.post(
      '/Order/Create',
      requestPayload
    );

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const getOrderByOrderId = async (orderID) => {
  try {
    const response = await axiosInstance.get(`/Orders/OrderID/${orderID}/Detail`);
    return response.data;
  } catch (e) {
    throw new Error('Error getOrderByOrderId');
  }
};
const downloadReport = async (OrderIDText, documentType) => {
  try {
    const response = await axiosInstance.get(`/Orders/OrderIDText/${OrderIDText}/Download?reportType=${documentType}`);
    return response.data;
  } catch (e) {
    throw new Error('Error downloading report');
  }
};
const OrderApi = {
  searchOrders,
  getOrderByOrderId,
  OrderCreate,
  downloadReport
};

export default OrderApi;
